/**
 * Utility functions for role domain management
 */

/**
 * Normalizes domains array to prevent duplicates
 * @param {Array} domains - Array of domain objects
 * @return {Array} - Normalized array with unique domains
 */
export function normalizeDomains(domains) {
    if (!domains || !Array.isArray(domains)) {
        return [];
    }
    
    const uniqueDomains = {};
    
    // Group permissions and fields by domain
    domains.forEach(domain => {
        if (!domain.domain) return; // Skip invalid entries
        
        if (!uniqueDomains[domain.domain]) {
            uniqueDomains[domain.domain] = {
                domain: domain.domain,
                permissions: [...(domain.permissions || [])],
                fields: [...(domain.fields || [])]
            };
        } else {
            // Merge permissions (unique values)
            const existingPerms = uniqueDomains[domain.domain].permissions;
            domain.permissions?.forEach(perm => {
                if (!existingPerms.includes(perm)) {
                    existingPerms.push(perm);
                }
            });
            
            // Merge fields with same key
            const existingFields = uniqueDomains[domain.domain].fields;
            domain.fields?.forEach(field => {
                if (!field.key) return;
                
                const existingField = existingFields.find(f => f.key === field.key);
                if (existingField) {
                    // Merge permissions for this field
                    field.permissions?.forEach(perm => {
                        if (!existingField.permissions.includes(perm)) {
                            existingField.permissions.push(perm);
                        }
                    });
                } else {
                    // Add new field
                    existingFields.push({
                        key: field.key,
                        permissions: [...(field.permissions || [])]
                    });
                }
            });
        }
    });
    
    return Object.values(uniqueDomains);
}